<template>
    <v-layout row wrap>
        <v-flex xs12 v-show="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-show="!loading">
            <k-p-i-value-boxes></k-p-i-value-boxes>
        </v-flex>

        <v-flex xs12 v-show="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Optimisation Savings
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12 lg7 v-if="data">
                        <vue-plotly :data="data" :layout="layout" :options="options" ref="plotly"/>
                    </v-flex>
                    <v-flex xs12 lg5>
                        <v-layout row wrap>
                            <v-flex xs12 lg6>
                                <value-box has-comma :value="totalSavingSum" unit="kWh" title="Saving after optimisation" icon="fa-piggy-bank"></value-box>
                            </v-flex>
                            <v-flex xs12 lg6>
                                <value-box has-comma :value="totalSavingSum*1.2" unit="HKD" title="HKD Savings" icon="fa-dollar-sign"></value-box>
                            </v-flex>
                            <v-flex xs12 lg6>
                                <value-box has-comma :value="totalPowerSum" unit="kWh" title="Actual usage after optimisation" icon="fa-bolt"></value-box>
                            </v-flex>
                            <v-flex xs12 lg6>
                                <value-box :value="savingPercentage" unit="%" title="Saving" icon="fa-smile" class="green-icon"></value-box>
                            </v-flex>

                            <v-flex xs12 lg6>
                                <value-box has-comma :value="totalSavingSum*0.51" unit="kgCO2e" title="Carbon Emissions Saved" icon="fa-industry"></value-box>
                            </v-flex>
                            <v-flex xs12 lg6>
                                <value-box has-comma :value="Math.round(totalSavingSum*0.039)" use-int title="Equivalent Trees Planted" icon="fa-tree"></value-box>
                            </v-flex>

                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
        <v-flex xs12 v-show="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Energy Consumption Trend
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12 v-if="data2">
                        <vue-plotly :data="data2" :layout="layout2" :options="options2"/>
                        <vue-plotly v-for="equipData in data2" v-if="equipData.hasOwnGraph" :data="[equipData]"
                                    :layout="{'title':equipData.name,'yaxis':{'title':'Energy consumption (kWh)'},'xaxis':{'title':'Time (daily)'}}" :options="{}"/>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>

        <v-flex xs12 v-show="!loading">
            <cooling-load-stacked-area-plot agg="H"></cooling-load-stacked-area-plot>
        </v-flex>
        <v-flex xs6 v-show="!loading">
            <cooling-load-forecast-new></cooling-load-forecast-new>
        </v-flex>
        <v-flex xs6 v-show="!loading">
            <v-card>
                <v-card-title class="accent white--text title">
                    Latest Cooling Load Forecast Accuracy
                    <v-spacer></v-spacer>
                    <v-btn color="primary" fab small dark @click.prevent="$refs.explanationDialog.openDialog()">
                        <v-icon>fa-info</v-icon>
                    </v-btn>
                    <cooling-load-explanation ref="explanationDialog"></cooling-load-explanation>
                </v-card-title>
                <v-card-text v-if="!loading">
                    <v-layout>
                        <v-flex xs12>
                            Forecast accuracy:
                            <vue-plotly v-if="data3" :data="data3" :layout="layout3" :options="options3"/>
                        </v-flex>

                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 v-show="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Algorithmic Fault Detection
                </v-card-title>
                <v-layout row wrap>

                    <v-flex xs12>
                        <v-card>
                            <v-card-text>
                                <date-range-selector v-model="range"></date-range-selector>
                                <equipment-selector typeFilter="chiller,pump" v-model="equipment"></equipment-selector>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12>
                        <anomaly :range="range" :equipment="equipment"></anomaly>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>



    </v-layout>
</template>

<script>
    import KPIValueBoxes from '../../components/kpi/KPIValueBoxes'
    import CoolingLoadStackedAreaPlot from '../../components/CoolingLoadStackedAreaPlot'
    import CoolingLoadForecastNew from '../../components/loadforecast/CoolingLoadForecastNew'
    import {callAPI,getResult,findLineByLeastSquares} from '@/helper'
    import VuePlotly from '@/components/VuePlotly'
    import ValueBox from '@/components/ValueBox'
    import CoolingLoadExplanation from '@/components/CoolingLoadExplanation'
    import moment from 'moment'
    import Anomaly from "../../components/Anomaly";
    import DateRangeSelector from "../../components/DateRangeSelector";
    import EquipmentSelector from "../../components/EquipmentSelector";



    export default {
        name: 'ShtDashboard',
        components: { KPIValueBoxes,CoolingLoadStackedAreaPlot,CoolingLoadForecastNew,VuePlotly,ValueBox,CoolingLoadExplanation,Anomaly,DateRangeSelector,EquipmentSelector},
        computed: {
            savingPercentage () {
                if(this.totalSavingSum===0){
                    return 0;
                }
                return 100*this.totalSavingSum/(this.totalSavingSum+this.totalPowerSum);
            }
        },
        data () {
            return {
                range: {start: '2019-09-27', end: '2019-10-01'},
                forcedBlue:[
                    "2019-08-27 00:00:00", "2019-08-28 00:00:00", "2019-08-29 00:00:00", "2019-08-30 00:00:00",
                    "2019-08-31 00:00:00", "2019-09-01 00:00:00", "2019-09-02 00:00:00", "2019-09-03 00:00:00",
                    "2019-10-29 00:00:00", "2019-10-31 00:00:00", "2019-11-05 00:00:00", "2019-11-07 00:00:00",
                    "2019-11-12 00:00:00", "2019-11-14 00:00:00", "2019-11-19 00:00:00", "2019-11-20 00:00:00",
                    "2019-12-24 00:00:00", "2019-12-25 00:00:00", "2020-01-03 00:00:00", "2020-01-07 00:00:00",
                    "2020-01-09 00:00:00", "2020-01-14 00:00:00", "2020-01-16 00:00:00", "2020-01-21 00:00:00",
                    "2020-01-23 00:00:00", "2020-01-28 00:00:00", "2020-01-30 00:00:00", "2020-02-04 00:00:00",
                    "2020-02-06 00:00:00", "2020-02-18 00:00:00", "2020-02-20 00:00:00", "2020-02-25 00:00:00",
                    "2020-02-27 00:00:00", "2020-03-03 00:00:00", "2020-03-05 00:00:00", "2020-03-12 00:00:00",
                    "2020-03-17 00:00:00", "2020-03-19 00:00:00",
                ],
                loading:false,
                equipment: 'ACPC-2',
                data:null,
                totalPowerSum:0,
                totalSavingSum:0,
                data2:null,
                data3:null,
                // data4:null,
                options: {},
                options2: {},
                options3: {},
                // options4: {},
                layout:{
                    hovermode: 'closest',
                    xaxis: {
                        title: 'Average outdoor air temperature (°C)',
                        range:[15,35]
                    },
                    yaxis: {
                        title: 'Total energy consumption (kWh)',
                        rangemode:'tozero',
                        range:[0,6000],
                    },
                    shapes: [

                    ],

                },
                layout2:{
                    yaxis: {
                        title: 'Energy consumption (kWh)'
                    },
                    xaxis: {
                        title: 'Time (daily)'
                    }
                },
                layout3:{
                    title: 'Cooling Load Accuracy',
                    hovermode: 'closest',
                    xaxis: {
                        title: 'Time (every 15 minutes)',
                    },
                    yaxis: {
                        title: 'Cooling Load (kW)'
                    },
                },
                // layout4:{
                //     title: 'Cooling Load Accuracy Trend',
                //     hovermode: 'closest',
                //     xaxis: {
                //         title: 'Time',
                //     },
                //     yaxis: {
                //         title: 'Difference'
                //     },
                // }

            }
        },
        methods:{
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    ar3.push(ar1[i] + ar2[i]);
                return ar3;
            },
            polyCurb(x){
                return(-0.21678982325554988*x*x*x*x + 20.499523198081228*x*x*x - 692.2944568911432*x*x + 10022.552049287606*x -52185.12514693242)
            }
        },
        mounted() {
            let rangeStart = _.get(this.$route.query,'rangeStart', null)
            if(!rangeStart){
                rangeStart=this.$store.state.pointsListStore.pointsList.facility_name=="SHT" ? "2019-08-27" : "2019-10-17"
            }
            let rangeEnd =  _.get(this.$route.query,'rangeEnd', moment().subtract(1, "days").format('YYYY-MM-DD'))
            let me=this;
            me.loading=true;
            let promises=[];
            let timestamp=null;
            let totalPower=null;
            let avgTemp=null;
            for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                if(equip.equipment_type==='chiller'){
                    promises.push(callAPI('data/',
                        {
                            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                            'equipment_name': equip.equipment_name,
                            'agg': 'D',
                            'agg_op': 'sum',
                            'date_range':[rangeStart, rangeEnd+" 23:59"],
                            'sensor_names': ['Comp_Power']
                        }
                    ))
                } else if(equip.equipment_type==='pump'){
                    promises.push(callAPI('data/',
                        {
                            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                            'equipment_name': equip.equipment_name,
                            'agg': 'D',
                            'agg_op': 'sum',
                            'date_range':[rangeStart, rangeEnd+" 23:59"],
                            'sensor_names': ['KW']
                        }
                    ))
                }
            }

            promises.push(callAPI('data/',
                {
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'equipment_name': 'Weather',
                    'agg': 'D',
                    'agg_op': 'mean',
                    'date_range':[rangeStart, rangeEnd+" 23:59"],
                    'sensor_names': ['Outdoor_Temperature']
                }
            ))


            Promise.all(promises).then(function(reses) {
                for (let res of reses){
                    if(!timestamp){
                        timestamp=res.data.timestamp;
                    }
                    if(res.data['Outdoor_Temperature']){
                        avgTemp=res.data['Outdoor_Temperature'];
                    } else {
                        if(!totalPower){
                            if(res.data['Comp_Power']){
                                totalPower=res.data['Comp_Power'];
                            } else if (res.data['KW']){
                                totalPower=res.data['KW'];
                            }
                        } else {
                            if(res.data['Comp_Power']){
                                totalPower=me.addArrays(totalPower,res.data['Comp_Power'])
                            } else if (res.data['KW']){
                                totalPower=me.addArrays(totalPower,res.data['KW'])
                            }
                        }
                    }

                }
                let preAvgTemp=[];
                let postAvgTemp=[];
                let preTotalPower=[];
                let postTotalPower=[];
                let preLabels=[];
                let postLabels=[];
                let totalPowerSum=0;
                let totalSavingSum=0;
                let polyCurbTemp=[];
                let polyCurbPower=[];
                for (let i=15; i<=32;i+=0.5){
                    polyCurbTemp.push(i);
                    polyCurbPower.push(me.polyCurb(i))
                }
                for (let k in timestamp){
                    if(me.forcedBlue.includes(timestamp[k])){
                        preAvgTemp.push(avgTemp[k]);
                        preTotalPower.push(totalPower[k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                        preLabels.push(timestamp[k].substring(0, 10));
                    } else {
                        postAvgTemp.push(avgTemp[k]);
                        postTotalPower.push(totalPower[k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                        postLabels.push(timestamp[k].substring(0, 10));
                    }
                }


                // let trendBeforeCurb=findLineByLeastSquares(preAvgTemp,preTotalPower)
                // let getY=function(x,trend){
                //     return ((x*trend[0])+trend[1])
                // }
                // let trendBefore=[[15,35],[getY(15,trendBeforeCurb),getY(35,trendBeforeCurb)]]
                for (let k in postAvgTemp){
                    if(postTotalPower[k]>0&&me.polyCurb(postAvgTemp[k])>0){
                        totalPowerSum+=postTotalPower[k];
                        totalSavingSum=totalSavingSum+me.polyCurb(postAvgTemp[k])-postTotalPower[k]
                    }
                }
                me.totalPowerSum=totalPowerSum;
                me.totalSavingSum=totalSavingSum;
                me.data = [
                    {
                        x: polyCurbTemp,
                        y: polyCurbPower,
                        name: 'BMS Trend Line',
                        line: {
                            color: 'rgb(31, 119, 180)',
                        },
                    },
                    {
                        x: preAvgTemp,
                        y: preTotalPower,
                        type: 'scattergl',
                        mode: 'markers',
                        name:"Before optimisation",
                        hovertext:preLabels,
                        marker: {
                            color: 'rgb(31, 119, 180)',
                        }
                    },
                    // {
                    //     x: trendBefore[0],
                    //     y: trendBefore[1],
                    //     type: 'scattergl',
                    //     name:"Before optimisation trend",
                    //     mode: 'lines',
                    //     line: {
                    //         color: 'rgb(31, 119, 180)',
                    //         width: 2,
                    //         dash:'dot'
                    //     }
                    // },
                    {
                        x: postAvgTemp,
                        y: postTotalPower,
                        type: 'scattergl',
                        mode: 'markers',
                        name:"After optimisation",
                        hovertext:postLabels,
                        marker: {
                            color: 'rgb(255, 127, 14)',
                        }
                    }
                ]
                let secondChartData = [];
                let colorMap={
                    "ACPC-1":"rgba(255, 127, 14,0.5)",
                    "ACPC-2":"rgba(214, 39, 40,0.5)",
                    "ACPC-3":"rgba(44, 160, 44, 0.5)",
                    "ACPC-4":"rgba(31, 119, 180,0.5)",
                    "ACPC-5": "rgba(148, 103, 189,0.5)",
                    "ACPC-6": "rgba(140, 86, 75,0.5)",
                    "ACPC-7": "rgba(227, 119, 194,0.5)",
                    "ACPC-8": "rgba(127, 127, 127,0.5)",
                    "ACPC-9": "rgba(188, 189, 34,0.5)",
                    "Chiller1": "rgba(255, 127, 14,0.5)",
                    "Chiller2": "rgba(214, 39, 40,0.5)",
                    "Chiller3": "rgba(44, 160, 44, 0.5)",
                    "Chiller4": "rgba(31, 119, 180,0.5)",
                    "Chiller5": "rgba(148, 103, 189,0.5)",
                    "Chiller6": "rgba(140, 86, 75,0.5)",
                    "Chiller7": "rgba(227, 119, 194,0.5)",
                    "Chiller8": "rgba(127, 127, 127,0.5)",
                    "Chiller9": "rgba(188, 189, 34,0.5)",
                };
                for (let res of reses) {
                    if (res.data['Comp_Power']) {
                        secondChartData.push({
                            x: timestamp,
                            y: res.data['Comp_Power'].map(i=>i/me.$store.state.pointsListStore.pointsList.sampling_freq),
                            name: JSON.parse(res.config.data)["equipment_name"],
                            fillcolor:colorMap[JSON.parse(res.config.data)["equipment_name"]],
                            hasOwnGraph:true,
                            stackgroup: 'one',
                            type: 'scatter',
                            mode: 'none'
                        });
                    } else if (res.data['KW']) {
                        secondChartData.push({
                            x: timestamp,
                            y: res.data['KW'].map(i=>i/me.$store.state.pointsListStore.pointsList.sampling_freq),
                            name: JSON.parse(res.config.data)["equipment_name"],
                            stackgroup: 'one',
                            type: 'scatter',
                            mode: 'none'
                        });
                    }
                }
                secondChartData.sort((a, b) => (a.name > b.name) ? 1 : -1)
                me.data2=secondChartData;
                me.loading=false;
            });

            getResult({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                result_name: 'cooling load'
            }).then(function(result){
                let actualdata = result['result'][0]['content']['df']
                let newdata = result['result'][0]['content']['forecast']
                me.data3=[
                    {
                        marker: {
                            color: 'rgb(0,0,0)',
                            shape: 'spline',
                            width: 1,
                            opacity: 0.9
                        },
                        x: actualdata.timestamp,
                        y: actualdata.total_CL,
                        name: 'Actual observed value',
                        type: 'scatter',
                        mode: 'lines'
                    },
                    {
                        line: {
                            color: 'rgb(0,76,255)',
                            shape: 'spline',
                            width: 1,
                            opacity: 0.9
                        },
                        x: newdata.timestamp,
                        y: newdata.yhat,
                        name: 'Predicted value',
                        type: 'scatter',
                        mode: 'lines'
                    },
                ]
                // let differential=[];
                // for(let tsindex in newdata.timestamp){
                //     let main=actualdata.total_CL[tsindex] ? actualdata.total_CL[tsindex] : 0
                //     if(main){
                //         differential.push(Math.abs((main-newdata.yhat[tsindex])/main * 100))
                //     } else {
                //         differential.push(0)
                //     }
                //
                // }
                // me.data4=[
                //     {
                //         x: newdata.timestamp,
                //         y: differential,
                //         name: 'Differential',
                //         type: 'scatter',
                //         mode: 'lines'
                //     },
                // ]
            });

        }


    }
</script>
<style>
    .green-icon .theme--light.v-icon{
        color: #77C16B;
    }
</style>
